enum BordereauStateStep {
	NOUVEAU = 1,
	EN_COURS = 2,
	NUMEROTE = 3,
	PES_EN_INSTANCE = 4,
	ATTENTE_TRANSMISSION_PARAPHEUR = 5,
	PREPARE_TDT = 6,
	EN_ECHEC = 7,
	ATTENTE_SIGNATURE = 8,
	REFUSE = 9,
	TRANSMIS_COMPTABLE = 10,
	FLUX_EMIS = 11,
	TELETRANSMIS = 12,
	NON_ACQUITTE = 13,
	ACQUITTE = 14,
	REJETE = 15,
	ARCHIVE = 16,
	INCONNU = 17,
	TRAITE_DGFIP = 18,
}

export default BordereauStateStep;
